// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as View from "../../primitives/View.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Request from "../../core/Request.res.js";
import * as NextPage from "../../resources/layout-and-structure/NextPage.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as NextBadge from "../../resources/feedback-indicators/NextBadge.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as KbdClipboard from "../../resources/typography/KbdClipboard.res.js";
import * as SpinnerModal from "../../resources/feedback-indicators/SpinnerModal.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as InputTextField from "../../resources/selection-and-input/InputTextField.res.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as SettingsRoutes from "./SettingsRoutes.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as SiretInputField from "../../modules/SiretInputField.res.js";
import * as TriggerDownload from "../../primitives/TriggerDownload.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CompanyLegalNumber from "../../modules/CompanyLegalNumber.res.js";
import * as InputCheckboxField from "../../resources/selection-and-input/InputCheckboxField.res.js";
import * as ElectronicInvoicing from "../../modules/ElectronicInvoicing/ElectronicInvoicing.res.js";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
let make = React.memo(props => {
  let notification = props.notification;
  if (notification === undefined) {
    return null;
  }
  let tmp;
  tmp = notification.TAG === "Ok" ? "success" : "danger";
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(NextBanner.make, {
      children: JsxRuntime.jsx(NextBanner.Text.make, {
        text: notification._0
      }),
      variation: tmp
    }),
    spaceX: "xsmall",
    spaceBottom: "large"
  });
});
let SettingsElectronicInvoicingNotificationBanner = {
  make: make
};
function SettingsElectronicInvoicingPage$SettingsElectronicInvoicingShopFieldset(props) {
  let onShopChange = props.onShopChange;
  let shops = Auth.useShops();
  let shopItems = shops.map(shop => ({
    TAG: "Option",
    key: shop.id,
    label: shop.name,
    value: shop.id
  }));
  let sections = [{
    items: shopItems
  }];
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Selected shop"),
    description: I18n.t("Select the store for which you want to view or modify information."),
    children: JsxRuntime.jsx(Select.make, {
      label: I18n.t("Shop"),
      preset: {
        NAME: "inputField",
        VAL: {
          required: false
        }
      },
      sections: sections,
      value: {
        TAG: "Single",
        _0: props.shop.id
      },
      onChange: change => {
        if (change.TAG !== "Single") {
          return;
        }
        let id = change._0;
        Stdlib_Option.forEach(shops.find(shop => shop.id === id), onShopChange);
      }
    })
  });
}
let SettingsElectronicInvoicingShopFieldset = {
  make: SettingsElectronicInvoicingPage$SettingsElectronicInvoicingShopFieldset
};
let i18nPrefix = "settings_electronic_invoicing_page.account_creation_modal.";
function splitName(name) {
  let parts = name.split(" ");
  let firstName = Stdlib_Option.getOr(parts[0], name);
  let lastName = parts.slice(1).join(" ");
  return [firstName, lastName];
}
let styles = {
  footer: {
    "borderTopColor-kLZC3w": "borderTopColor-x7i6r9d",
    "borderTopStyle-kPef9Z": "borderTopStyle-x13fuv20",
    "borderTopWidth-kEafiO": "borderTopWidth-x178xt8z",
    "display-k1xSpc": "display-x78zum5",
    "gap-kOIVth": "gap-x167g77z",
    "justifyContent-kjj79g": "justifyContent-x13a6bvl",
    "padding-kmVPX3": "padding-x1tamke2",
    $$css: "wino-gc:src/app/Settings/SettingsElectronicInvoicingPage.res.js:130"
  }
};
function get(values, field) {
  switch (field) {
    case "SiretNumber":
      return values.siretNumber;
    case "VatNumber":
      return values.vatNumber;
    case "CorporateName":
      return values.corporateName;
    case "Email":
      return values.email;
    case "FirstName":
      return values.firstName;
    case "LastName":
      return values.lastName;
    case "TaxationRegime":
      return values.taxationRegime;
    case "EmployeesNumber":
      return values.employeesNumber;
  }
}
function set(values, field, value) {
  switch (field) {
    case "SiretNumber":
      return {
        siretNumber: value,
        vatNumber: values.vatNumber,
        corporateName: values.corporateName,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        taxationRegime: values.taxationRegime,
        employeesNumber: values.employeesNumber
      };
    case "VatNumber":
      return {
        siretNumber: values.siretNumber,
        vatNumber: value,
        corporateName: values.corporateName,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        taxationRegime: values.taxationRegime,
        employeesNumber: values.employeesNumber
      };
    case "CorporateName":
      return {
        siretNumber: values.siretNumber,
        vatNumber: values.vatNumber,
        corporateName: value,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        taxationRegime: values.taxationRegime,
        employeesNumber: values.employeesNumber
      };
    case "Email":
      return {
        siretNumber: values.siretNumber,
        vatNumber: values.vatNumber,
        corporateName: values.corporateName,
        email: value,
        firstName: values.firstName,
        lastName: values.lastName,
        taxationRegime: values.taxationRegime,
        employeesNumber: values.employeesNumber
      };
    case "FirstName":
      return {
        siretNumber: values.siretNumber,
        vatNumber: values.vatNumber,
        corporateName: values.corporateName,
        email: values.email,
        firstName: value,
        lastName: values.lastName,
        taxationRegime: values.taxationRegime,
        employeesNumber: values.employeesNumber
      };
    case "LastName":
      return {
        siretNumber: values.siretNumber,
        vatNumber: values.vatNumber,
        corporateName: values.corporateName,
        email: values.email,
        firstName: values.firstName,
        lastName: value,
        taxationRegime: values.taxationRegime,
        employeesNumber: values.employeesNumber
      };
    case "TaxationRegime":
      return {
        siretNumber: values.siretNumber,
        vatNumber: values.vatNumber,
        corporateName: values.corporateName,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        taxationRegime: value,
        employeesNumber: values.employeesNumber
      };
    case "EmployeesNumber":
      return {
        siretNumber: values.siretNumber,
        vatNumber: values.vatNumber,
        corporateName: values.corporateName,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        taxationRegime: values.taxationRegime,
        employeesNumber: value
      };
  }
}
let Lenses = {
  get: get,
  set: set
};
let Lenses$1 = {
  Lenses: Lenses,
  get: get,
  set: set
};
let AccountCreationForm = Form.Make({
  get: get,
  set: set
});
function isValidBelgianVatNumber(value) {
  return value.length === 12;
}
function schema(isBelgianShop) {
  let identifierRule = isBelgianShop ? {
    TAG: "CustomString",
    _0: "VatNumber",
    _1: (value, param) => {
      if (value.length !== 12) {
        return {
          TAG: "Error",
          _0: I18n.t(i18nPrefix + "form.vat_number.error_message")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  } : {
    TAG: "CustomString",
    _0: "SiretNumber",
    _1: (value, param) => {
      if (CompanyLegalNumber.French.isValidSiret(value)) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: ""
        };
      }
    }
  };
  return [identifierRule, {
    TAG: "StringNotEmpty",
    _0: "CorporateName"
  }, {
    TAG: "Email",
    _0: "Email"
  }, {
    TAG: "StringNotEmpty",
    _0: "FirstName"
  }, {
    TAG: "StringNotEmpty",
    _0: "LastName"
  }, {
    TAG: "OptionDefined",
    _0: "TaxationRegime"
  }, {
    TAG: "OptionDefined",
    _0: "EmployeesNumber"
  }];
}
function SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountCreationModal$SiretField(props) {
  let match = AccountCreationForm.useField("SiretNumber", undefined, undefined, undefined, undefined);
  let onFocus = match.onFocus;
  return JsxRuntime.jsx(SiretInputField.make, {
    value: match.value,
    errored: Stdlib_Option.isSome(match.error),
    focused: match.focused,
    required: match.required,
    onChange: match.onChange,
    onCompanyFound: props.onCompanyFound,
    onFocus: () => onFocus(),
    onBlur: match.onBlur
  });
}
let SiretField = {
  make: SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountCreationModal$SiretField
};
function SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountCreationModal(props) {
  let onCommit = props.onCommit;
  let onRequestOpenChange = props.onRequestOpenChange;
  let user = props.user;
  let shop = props.shop;
  let match = splitName(user.name);
  let isBelgianShop = ElectronicInvoicing.isShopFromBelgium(shop);
  let formPropState = AccountCreationForm.useFormPropState({
    initialValues: {
      siretNumber: Stdlib_Option.getOr(shop.siretNumber, ""),
      vatNumber: Stdlib_Option.getOr(shop.tvaNumber, ""),
      corporateName: shop.corporateName,
      email: user.username,
      firstName: match[0],
      lastName: match[1],
      taxationRegime: ElectronicInvoicing.TaxationRegime.fromShop(shop),
      employeesNumber: ElectronicInvoicing.EmployeesNumber.fromShop(shop)
    },
    schema: schema(isBelgianShop)
  });
  let values = formPropState[0].values;
  let formDispatch = formPropState[1];
  let match$1 = React.useState(() => false);
  let setSiretNumberNotFound = match$1[1];
  let match$2 = React.useState(() => {});
  let setLegalForm = match$2[1];
  let legalForm = match$2[0];
  React.useEffect(() => {
    let value = values.siretNumber.trim().replaceAll(" ", "");
    if (value !== values.siretNumber) {
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "SiretNumber",
        _1: param => value
      });
    }
  }, [values.siretNumber]);
  React.useEffect(() => {
    let value = values.vatNumber.trim().replaceAll(" ", "");
    if (value !== values.vatNumber) {
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "VatNumber",
        _1: param => value
      });
    }
  }, [values.vatNumber]);
  React.useEffect(() => {
    setSiretNumberNotFound(param => false);
    setLegalForm(param => {});
  }, [values.siretNumber]);
  let handleSiretCompanyFound = lookup => {
    if (lookup !== undefined) {
      let company = lookup.company;
      let legalForm = lookup.legalForm;
      setSiretNumberNotFound(param => false);
      setLegalForm(param => legalForm);
      return formDispatch({
        TAG: "FieldValueChanged",
        _0: "CorporateName",
        _1: param => company.corporateName
      });
    }
    setSiretNumberNotFound(param => true);
    setLegalForm(param => {});
  };
  let privacyRight = typeof legalForm === "object" ? legalForm.privacyRight : false;
  let onSubmit = (param, values) => {
    let match = values.taxationRegime;
    let match$1 = values.employeesNumber;
    if (match === undefined) {
      return Future.value({
        TAG: "Error",
        _0: Request.serverErrorMessage
      });
    }
    if (match$1 === undefined) {
      return Future.value({
        TAG: "Error",
        _0: Request.serverErrorMessage
      });
    }
    let siretNumber = values.siretNumber !== "" ? values.siretNumber : undefined;
    let vatNumber = values.vatNumber !== "" ? values.vatNumber : undefined;
    return Future.mapError(Future.mapOk(onCommit(isBelgianShop ? undefined : siretNumber, isBelgianShop ? vatNumber : undefined, values.firstName, values.lastName, values.corporateName, values.email, match, match$1), undefined, () => {}), undefined, param => Request.serverErrorMessage);
  };
  let newrecord = {
    ...{
      className: "borderTopColor-x7i6r9d borderTopStyle-x13fuv20 borderTopWidth-x178xt8z display-x78zum5 gap-x167g77z justifyContent-x13a6bvl padding-x1tamke2",
      "data-style-src": "wino-gc:src/app/Settings/SettingsElectronicInvoicingPage.res.js:130"
    }
  };
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsxs(AccountCreationForm.Core.Provider.make, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t(i18nPrefix + "intro_text")
            }), JsxRuntime.jsxs(Stack.make, {
              children: [JsxRuntime.jsxs(InlineText.make, {
                children: [JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t(i18nPrefix + "step_one.label"),
                  weight: "semibold"
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t(i18nPrefix + "step_one.description")
                })]
              }), JsxRuntime.jsxs(InlineText.make, {
                children: [JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t(i18nPrefix + "step_two.label"),
                  weight: "semibold"
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t(i18nPrefix + "step_two.description")
                })]
              }), JsxRuntime.jsxs(InlineText.make, {
                children: [JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t(i18nPrefix + "step_three.label"),
                  weight: "semibold"
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t(i18nPrefix + "step_three.description")
                })]
              })],
              space: "xxsmall"
            }), JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t(i18nPrefix + "outro_text")
            })],
            space: "normal"
          }), JsxRuntime.jsxs(NextBanner.make, {
            children: [JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t(i18nPrefix + "banner.issuing.text_part_1_bold"),
              bold: true
            }), JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t(i18nPrefix + "banner.issuing.text_part_2")
            }), JsxRuntime.jsx(NextBanner.Gap.make, {
              space: "xsmall"
            }), JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t(i18nPrefix + "banner.receiving.text_part_1")
            }), JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t(i18nPrefix + "banner.receiving.text_part_2_bold"),
              bold: true
            })],
            variation: "info",
            title: I18n.t(i18nPrefix + "banner.title")
          }), JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(Title.make, {
              children: I18n.t(i18nPrefix + "form.title"),
              level: 4,
              weight: "semibold"
            }), isBelgianShop ? JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsx(AccountCreationForm.InputText.make, {
                field: "VatNumber",
                label: I18n.t(i18nPrefix + "form.vat_number.label"),
                placeholder: I18n.t(i18nPrefix + "form.vat_number.placeholder"),
                disabled: true
              }),
              space: "small",
              alignY: "top"
            }) : JsxRuntime.jsx(SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountCreationModal$SiretField, {
              onCompanyFound: handleSiretCompanyFound
            }), JsxRuntime.jsxs(Inline.make, {
              children: [JsxRuntime.jsx(AccountCreationForm.InputText.make, {
                field: "CorporateName",
                label: I18n.t(i18nPrefix + "form.corporate_name.label"),
                placeholder: isBelgianShop ? I18n.t(i18nPrefix + "form.corporate_name.belgian_placeholder") : I18n.t(i18nPrefix + "form.corporate_name.placeholder"),
                disabled: !isBelgianShop && !privacyRight
              }), JsxRuntime.jsx(AccountCreationForm.InputText.make, {
                field: "Email",
                label: I18n.t(i18nPrefix + "form.email.label"),
                placeholder: I18n.t(i18nPrefix + "form.email.placeholder")
              })],
              space: "large",
              alignY: "top"
            }), JsxRuntime.jsx(SiretInputField.LegalFormBanner.make, {
              legalForm: legalForm
            }), JsxRuntime.jsxs(Inline.make, {
              children: [JsxRuntime.jsx(AccountCreationForm.InputText.make, {
                field: "FirstName",
                label: I18n.t(i18nPrefix + "form.first_name.label"),
                placeholder: I18n.t(i18nPrefix + "form.first_name.placeholder")
              }), JsxRuntime.jsx(AccountCreationForm.InputText.make, {
                field: "LastName",
                label: I18n.t(i18nPrefix + "form.last_name.label"),
                placeholder: I18n.t(i18nPrefix + "form.last_name.placeholder")
              })],
              space: "large",
              alignY: "top"
            }), JsxRuntime.jsxs(Group.make, {
              children: [JsxRuntime.jsx(AccountCreationForm.InputSelect.make, {
                field: "TaxationRegime",
                label: I18n.t(i18nPrefix + "form.taxation_regime.label"),
                placeholder: I18n.t(i18nPrefix + "form.taxation_regime.placeholder"),
                sections: ElectronicInvoicing.TaxationRegime.selectSections
              }), JsxRuntime.jsx(AccountCreationForm.InputSelect.make, {
                field: "EmployeesNumber",
                label: I18n.t(i18nPrefix + "form.employees_number.label"),
                placeholder: I18n.t(i18nPrefix + "form.employees_number.placeholder"),
                sections: ElectronicInvoicing.EmployeesNumber.selectSections
              })]
            })],
            space: "medium"
          })],
          space: "large"
        }),
        spaceX: "large",
        spaceY: "large"
      }), JsxRuntime.jsxs("div", (newrecord.children = [JsxRuntime.jsx(Button.make, {
        label: I18n.t("Cancel"),
        onPress: () => onRequestOpenChange(false)
      }), JsxRuntime.jsx(AccountCreationForm.SubmitButton.make, {
        label: I18n.t(i18nPrefix + "submit_button_label"),
        tone: "brand",
        disabled: match$1[0],
        onSubmit: onSubmit
      })], newrecord))],
      propState: formPropState
    }),
    opened: props.opened,
    title: I18n.t(i18nPrefix + "title"),
    backgroundColor: "white",
    hideFooter: true,
    onRequestClose: () => onRequestOpenChange(false)
  });
}
let SettingsElectronicInvoicingAccountCreationModal = {
  i18nPrefix: i18nPrefix,
  splitName: splitName,
  styles: styles,
  Lenses: Lenses$1,
  AccountCreationForm: AccountCreationForm,
  isValidBelgianVatNumber: isValidBelgianVatNumber,
  schema: schema,
  SiretField: SiretField,
  make: SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountCreationModal
};
function SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountSetupFieldset(props) {
  let onSetup = props.onSetup;
  let __setupRedirected = props.setupRedirected;
  let setupRedirected = __setupRedirected !== undefined ? __setupRedirected : false;
  let match = React.useState(() => setupRedirected);
  let setAccountCreationModalOpened = match[1];
  let match$1 = React.useState(() => false);
  let setAccountCreationPending = match$1[1];
  let setAccountCreationModalOpened$1 = opened => {
    setAccountCreationModalOpened(param => opened);
    Navigation.openRoute(opened ? SettingsRoutes.electronicInvoicingSetupRoute : SettingsRoutes.electronicInvoicingRoute);
  };
  React.useEffect(() => {
    if (setupRedirected) {
      setAccountCreationModalOpened$1(true);
    }
  }, [setupRedirected]);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
      title: I18n.t("settings_electronic_invoicing_page.account_fieldset.title"),
      description: I18n.t("settings_electronic_invoicing_page.account_fieldset.description"),
      children: [JsxRuntime.jsx(CanarySurface.make, {
        tone: "neutral-ghost",
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx("img", {
              style: {
                margin: "auto",
                width: "175px"
              },
              alt: "e-invoicing",
              src: ElectronicInvoicing.illustrationSrc
            }), JsxRuntime.jsxs(Stack.make, {
              children: [JsxRuntime.jsx(Box.make, {
                children: JsxRuntime.jsx(Title.make, {
                  children: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.title"),
                  level: 3,
                  align: "center",
                  weight: "bold",
                  color: "#25243A"
                }),
                spaceBottom: "xmedium"
              }), JsxRuntime.jsxs(InlineText.make, {
                children: [JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.content.part_1"),
                  size: "small"
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: " eFacture (Cecurity)",
                  weight: "semibold",
                  size: "small"
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.content.part_2"),
                  size: "small"
                }), JsxRuntime.jsx("br", {}), JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.content_caption_part_1"),
                  weight: "semibold",
                  size: "small"
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: ", " + I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.content_caption_part_2"),
                  size: "small"
                })],
                align: "center"
              })],
              space: "none"
            }), JsxRuntime.jsxs(Inline.make, {
              children: [JsxRuntime.jsx(Button.make, {
                label: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.helpcenter_button_label"),
                size: "medium",
                trailingIcon: "help_center",
                onPress: () => HelpCenter.showArticle(HelpCenter.eInvoicingHowTo)
              }), JsxRuntime.jsx(Button.make, {
                label: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.create_button_label"),
                variant: {
                  NAME: "ghost",
                  VAL: {
                    bordered: true
                  }
                },
                tone: "brand",
                size: "medium",
                onPress: () => setAccountCreationModalOpened$1(true)
              })],
              space: "xnormal",
              align: "center"
            })],
            space: "large"
          }),
          spaceX: "large",
          spaceY: "xlarge"
        })
      }), JsxRuntime.jsx(SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountCreationModal, {
        opened: match[0],
        shop: props.shop,
        user: props.user,
        onRequestOpenChange: setAccountCreationModalOpened$1,
        onCommit: (siretNumber, vatNumber, userFirstName, userLastName, corporateName, email, taxationRegime, employeesNumber) => {
          setAccountCreationModalOpened$1(false);
          setAccountCreationPending(param => true);
          return Future.tap(onSetup(siretNumber, vatNumber, userFirstName, userLastName, corporateName, email, taxationRegime, employeesNumber), param => setAccountCreationPending(param => false));
        }
      })]
    }), JsxRuntime.jsx(SpinnerModal.make, {
      title: I18n.t("settings_electronic_invoicing_page.account_creation_modal.spinner_title"),
      opened: match$1[0]
    })]
  });
}
let SettingsElectronicInvoicingAccountSetupFieldset = {
  make: SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountSetupFieldset
};
let i18nContentPrefix = "settings_electronic_invoicing_page.account_status_fieldset.content.";
function SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountStatusFieldset(props) {
  let onEnrollmentAgreementStart = props.onEnrollmentAgreementStart;
  let onContractDownload = props.onContractDownload;
  let __hideContractDownloadButton = props.hideContractDownloadButton;
  let isBelgianShop = props.isBelgianShop;
  let thirdPartyPlatformEnabled = props.thirdPartyPlatformEnabled;
  let enrollmentAgreementLink = props.enrollmentAgreementLink;
  let enrollmentStatus = props.enrollmentStatus;
  let hideContractDownloadButton = __hideContractDownloadButton !== undefined ? __hideContractDownloadButton : false;
  let receivingEnabled = enrollmentStatus === "Signed";
  let receivingInactive = enrollmentStatus === "Inactive";
  let tmp;
  if (receivingEnabled) {
    tmp = JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx(Icon.make, {
            name: "import",
            fill: "#25243A",
            width: 20,
            height: 20
          }), JsxRuntime.jsx(Title.make, {
            children: I18n.t(i18nContentPrefix + "receiving.title"),
            level: 5,
            weight: "semibold"
          }), JsxRuntime.jsx(Badge.make, {
            children: I18n.t("Enabled{{feminine}}"),
            size: "small",
            borderColor: "#66EFAC",
            backgroundColor: "#EBFEF3",
            foregroundColor: "#00653E"
          })],
          space: "small"
        }), JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t(i18nContentPrefix + "receiving.enabled.description"),
          variation: "normal",
          size: "small"
        })],
        space: "small",
        align: "start"
      }), hideContractDownloadButton ? null : JsxRuntime.jsx(Button.make, {
        label: I18n.t(i18nContentPrefix + "receiving.enabled.download_contract_button_label"),
        tone: "information",
        size: "small",
        disabled: thirdPartyPlatformEnabled,
        pending: props.contractDownloadPending,
        noShrink: true,
        trailingIcon: "download_v1",
        onPress: () => onContractDownload()
      })],
      space: "xxlarge",
      align: "spaceBetween"
    });
  } else {
    let styleSet = ElectronicInvoicing.Settings.EnrollmentStatus.Badge.toStyleSet(enrollmentStatus);
    tmp = JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx(Icon.make, {
            name: "import",
            fill: "#25243A",
            width: 20,
            height: 20
          }), JsxRuntime.jsx(Title.make, {
            children: I18n.t(i18nContentPrefix + "receiving.title"),
            level: 5,
            weight: "semibold",
            color: thirdPartyPlatformEnabled ? "#8c8B9b" : "#25243a"
          }), JsxRuntime.jsx(Badge.make, {
            children: ElectronicInvoicing.Settings.EnrollmentStatus.toLabel(enrollmentStatus),
            size: "small",
            borderColor: styleSet.borderColor,
            backgroundColor: styleSet.bgColor,
            foregroundColor: styleSet.textColor
          })],
          space: "small"
        }), JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t(i18nContentPrefix + (`receiving.` + (receivingInactive ? "inactive" : "disabled") + `.description`)),
          variation: "normal",
          size: "small"
        })],
        space: "small"
      }), View._if(!receivingInactive && Stdlib_Option.isSome(enrollmentAgreementLink), () => JsxRuntime.jsx(Button.make, {
        label: I18n.t(i18nContentPrefix + "receiving.disabled.enroll_button_label"),
        variant: {
          NAME: "ghost",
          VAL: {
            bordered: true
          }
        },
        tone: "brand",
        size: "small",
        disabled: thirdPartyPlatformEnabled,
        noShrink: true,
        trailingIcon: "legacy_external_link",
        href: enrollmentAgreementLink,
        target: "_blank",
        onPress: () => onEnrollmentAgreementStart()
      }))],
      align: "spaceBetween"
    });
  }
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("settings_electronic_invoicing_page.account_fieldset.title"),
    description: I18n.t("settings_electronic_invoicing_page.account_active_fieldset.description"),
    children: [JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(Title.make, {
          children: I18n.t(i18nContentPrefix + "title"),
          level: 4,
          weight: "semibold"
        }), JsxRuntime.jsx(CanarySeparator.make, {
          size: "small"
        }), JsxRuntime.jsx(Title.make, {
          children: I18n.t(i18nContentPrefix + "subtitle.login_name"),
          level: 5,
          color: "#767589"
        }), JsxRuntime.jsx(KbdClipboard.make, {
          size: "small",
          cropValueAt: 100,
          value: props.accountLoginName
        })],
        space: "xsmall"
      }), JsxRuntime.jsx(Button.make, {
        label: I18n.t(i18nContentPrefix + "header.button_label"),
        size: "small",
        trailingIcon: "external_link",
        href: props.accountLink,
        target: "_blank"
      })],
      space: "large",
      align: "spaceBetween"
    }), JsxRuntime.jsx(CanarySurface.make, {
      tone: "neutral-ghost",
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(Icon.make, {
              name: "export",
              fill: "#25243A",
              width: 20,
              height: 20
            }), JsxRuntime.jsx(Title.make, {
              children: I18n.t(i18nContentPrefix + "issuing.title"),
              level: 5,
              weight: "semibold"
            }), JsxRuntime.jsx(Badge.make, {
              children: I18n.t("Enabled{{feminine}}"),
              size: "small",
              borderColor: "#66EFAC",
              backgroundColor: "#EBFEF3",
              foregroundColor: "#00653E"
            }), props.missingInvoicingAddress ? JsxRuntime.jsx(Badge.make, {
              children: I18n.t(i18nContentPrefix + "issuing.missing_invoicing_address_badge.label"),
              iconSvg: JsxRuntime.jsx(Icon.make, {
                name: "status_warning",
                fill: "#7C2112",
                width: 11,
                height: 11,
                bold: true
              }),
              size: "small",
              borderColor: "#FDAB74",
              backgroundColor: "#FFE5CF",
              foregroundColor: "#7C2112"
            }) : null],
            space: "small"
          }), JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t(i18nContentPrefix + (`issuing.` + (isBelgianShop ? "belgian_shop.description" : "description"))),
            variation: "normal",
            size: "small"
          })],
          space: "small",
          align: "start"
        }),
        spaceX: "medium",
        spaceY: "medium"
      })
    }), JsxRuntime.jsx(CanarySurface.make, {
      tone: "neutral-ghost",
      borderStyle: receivingEnabled ? "solid" : "dashed",
      opacity: thirdPartyPlatformEnabled ? 0.5 : 1,
      children: JsxRuntime.jsx(Box.make, {
        children: tmp,
        spaceX: "medium",
        spaceY: "medium"
      })
    }), receivingEnabled ? null : JsxRuntime.jsx(InputCheckboxField.make, {
      text: I18n.t(i18nContentPrefix + (isBelgianShop ? "receiving.third_party_platform_checkbox.belgian_text" : "receiving.third_party_platform_checkbox.text")),
      value: thirdPartyPlatformEnabled,
      onChange: props.onThirdPartyPlatformToggle
    })]
  });
}
let SettingsElectronicInvoicingAccountStatusFieldset = {
  i18nContentPrefix: i18nContentPrefix,
  make: SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountStatusFieldset
};
function SettingsElectronicInvoicingPage$SettingsElectronicInvoicingGuideFieldset(props) {
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(CanarySurface.make, {
        tone: "neutral-ghost",
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx("img", {
            style: {
              width: "106px",
              alignSelf: "center"
            },
            alt: "e-invoicing",
            src: ElectronicInvoicing.illustrationSrc
          }),
          spaceX: "xxlarge",
          spaceY: "medium"
        })
      }), JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(Title.make, {
          children: I18n.t("settings_electronic_invoicing_page.guide_fieldset.content.title"),
          level: 4,
          weight: "semibold"
        }), JsxRuntime.jsxs(InlineText.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("settings_electronic_invoicing_page.guide_fieldset.content.description.part_1"),
            size: "small"
          }), JsxRuntime.jsx(TextStyle.make, {
            children: "eFacture (Cecurity)",
            weight: "semibold",
            size: "small"
          }), JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("settings_electronic_invoicing_page.guide_fieldset.content.description.part_2"),
            size: "small"
          })]
        }), JsxRuntime.jsx(TextAction.make, {
          text: I18n.t("Learn more"),
          highlighted: true,
          onPress: () => HelpCenter.showArticle(HelpCenter.eInvoicingHowTo)
        })],
        space: "large",
        align: "start"
      })],
      space: "large"
    })
  });
}
let SettingsElectronicInvoicingGuideFieldset = {
  make: SettingsElectronicInvoicingPage$SettingsElectronicInvoicingGuideFieldset
};
function get$1(values, field) {
  switch (field) {
    case "FrenchKind":
      return values.frenchKind;
    case "BelgianKind":
      return values.belgianKind;
    case "Identifier":
      return values.identifier;
    case "Suffix":
      return values.suffix;
    case "RoutingCode":
      return values.routingCode;
  }
}
function set$1(values, field, value) {
  switch (field) {
    case "FrenchKind":
      return {
        frenchKind: value,
        belgianKind: values.belgianKind,
        identifier: values.identifier,
        suffix: values.suffix,
        routingCode: values.routingCode
      };
    case "BelgianKind":
      return {
        frenchKind: values.frenchKind,
        belgianKind: value,
        identifier: values.identifier,
        suffix: values.suffix,
        routingCode: values.routingCode
      };
    case "Identifier":
      return {
        frenchKind: values.frenchKind,
        belgianKind: values.belgianKind,
        identifier: value,
        suffix: values.suffix,
        routingCode: values.routingCode
      };
    case "Suffix":
      return {
        frenchKind: values.frenchKind,
        belgianKind: values.belgianKind,
        identifier: values.identifier,
        suffix: value,
        routingCode: values.routingCode
      };
    case "RoutingCode":
      return {
        frenchKind: values.frenchKind,
        belgianKind: values.belgianKind,
        identifier: values.identifier,
        suffix: values.suffix,
        routingCode: value
      };
  }
}
let Lenses$2 = {
  get: get$1,
  set: set$1
};
let AddressFormLenses = {
  Lenses: Lenses$2,
  get: get$1,
  set: set$1
};
let AddressForm = Form.Make({
  get: get$1,
  set: set$1
});
function shopIdentifier(siret, vatNumber, isBelgianShop) {
  if (isBelgianShop) {
    return Stdlib_Option.filter(vatNumber, vatNumber => ElectronicInvoicing.InvoicingEndpoint.Belgian.isValidIdentifier("VatNumber", vatNumber));
  } else {
    return Stdlib_Option.filter(siret, CompanyLegalNumber.French.isValidSiret);
  }
}
function initialValues(initialValue, siret, vatNumber, isBelgianShop) {
  let identifier = Stdlib_Option.getOr(isBelgianShop ? vatNumber : siret, "");
  let endpointId = Stdlib_Option.map(initialValue, value => value.endpointId);
  let schemeType = Stdlib_Option.flatMap(initialValue, value => value.schemeType);
  let match = ElectronicInvoicing.InvoicingEndpoint.French.fromEndpoint(schemeType, endpointId);
  return {
    frenchKind: match[0],
    belgianKind: Stdlib_Option.getOr(Stdlib_Option.flatMap(schemeType, ElectronicInvoicing.InvoicingEndpoint.Belgian.fromSchemeType), "BceNumber"),
    identifier: identifier,
    suffix: match[1],
    routingCode: match[2]
  };
}
function endpointFromValues(values, isBelgianShop) {
  if (isBelgianShop) {
    return ElectronicInvoicing.InvoicingEndpoint.Belgian.makeEndpoint(values.belgianKind, values.identifier);
  } else {
    return ElectronicInvoicing.InvoicingEndpoint.French.makeEndpoint(values.frenchKind, values.identifier, values.suffix, values.routingCode);
  }
}
function schema$1(isBelgianShop, editable) {
  let identifierRules = editable ? isBelgianShop ? [{
    TAG: "Custom",
    _0: "Identifier",
    _1: param => ElectronicInvoicing.InvoicingEndpoint.Belgian.validateIdentifier(param.belgianKind, param.identifier)
  }] : [{
    TAG: "Custom",
    _0: "Identifier",
    _1: param => ElectronicInvoicing.InvoicingEndpoint.French.validateIdentifier(param.frenchKind, param.identifier)
  }] : [];
  let complementRules = isBelgianShop ? [] : [{
    TAG: "Custom",
    _0: "Suffix",
    _1: param => ElectronicInvoicing.InvoicingEndpoint.French.validateSuffix(param.frenchKind, param.suffix)
  }, {
    TAG: "Custom",
    _0: "RoutingCode",
    _1: param => ElectronicInvoicing.InvoicingEndpoint.French.validateRoutingCode(param.frenchKind, param.routingCode)
  }];
  return identifierRules.concat(complementRules);
}
function SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAddressFieldset(props) {
  let onSubmit = props.onSubmit;
  let isBelgianShop = props.isBelgianShop;
  let vatNumber = props.vatNumber;
  let siret = props.siret;
  let initialValue = props.initialValue;
  let shopId = props.shopId;
  let captureEvent = SessionTracker.useCaptureEvent();
  let shopIdentifier$1 = shopIdentifier(siret, vatNumber, isBelgianShop);
  let editable = Stdlib_Option.isNone(shopIdentifier$1);
  let formPropState = AddressForm.useFormPropState({
    id: shopId + Stdlib_Option.getOr(shopIdentifier$1, ""),
    initialValues: initialValues(initialValue, siret, vatNumber, isBelgianShop),
    schema: schema$1(isBelgianShop, editable)
  });
  let match = formPropState[0];
  let values = match.values;
  let match$1 = React.useState(() => initialValue === undefined);
  let setEditing = match$1[1];
  let editing = match$1[0];
  ReactUpdateEffect.use1(() => {
    setEditing(param => initialValue === undefined);
  }, [shopId]);
  let fieldsElement;
  if (isBelgianShop) {
    let label = ElectronicInvoicing.InvoicingEndpoint.Belgian.identifierLabel(values.belgianKind);
    fieldsElement = JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(AddressForm.InputSelect.make, {
        field: "BelgianKind",
        label: ElectronicInvoicing.InvoicingEndpoint.selectLabel,
        sections: ElectronicInvoicing.InvoicingEndpoint.Belgian.selectSections,
        hideRequired: true
      }), editable ? JsxRuntime.jsx(AddressForm.InputText.make, {
        field: "Identifier",
        label: label,
        placeholder: ElectronicInvoicing.InvoicingEndpoint.Belgian.identifierPlaceholder(values.belgianKind),
        hideRequired: true
      }) : JsxRuntime.jsx(InputTextField.make, {
        label: label,
        disabled: true,
        value: ElectronicInvoicing.InvoicingEndpoint.Belgian.endpointId(values.belgianKind, values.identifier)
      })],
      grid: ["max-content", "1fr"]
    });
  } else {
    let identifierIsSiren = ElectronicInvoicing.InvoicingEndpoint.French.identifierIsSiren(values.frenchKind);
    let match$2 = values.frenchKind;
    let tmp;
    let exit = 0;
    switch (match$2) {
      case "Siren":
        tmp = null;
        break;
      case "SirenWithSuffix":
        tmp = JsxRuntime.jsx(AddressForm.InputText.make, {
          field: "Suffix",
          label: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.suffix_input.label"),
          placeholder: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.suffix_input.placeholder"),
          hideRequired: true,
          maxLength: ElectronicInvoicing.InvoicingEndpoint.French.complementMaxLength
        });
        break;
      case "Siret":
      case "SiretWithRoutingCode":
        exit = 1;
        break;
    }
    if (exit === 1) {
      tmp = editable ? JsxRuntime.jsx(AddressForm.InputText.make, {
        field: "Identifier",
        label: ElectronicInvoicing.InvoicingEndpoint.French.identifierLabel("Siret"),
        placeholder: ElectronicInvoicing.InvoicingEndpoint.French.identifierPlaceholder("Siret")
      }) : JsxRuntime.jsx(InputTextField.make, {
        label: ElectronicInvoicing.InvoicingEndpoint.French.identifierLabel("Siret"),
        disabled: true,
        value: values.identifier
      });
    }
    let match$3 = values.frenchKind;
    let tmp$1;
    tmp$1 = match$3 === "SiretWithRoutingCode" ? JsxRuntime.jsx(AddressForm.InputText.make, {
      field: "RoutingCode",
      label: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.routing_code_input.label"),
      placeholder: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.routing_code_input.placeholder"),
      maxLength: ElectronicInvoicing.InvoicingEndpoint.French.complementMaxLength
    }) : null;
    fieldsElement = JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(AddressForm.InputSelect.make, {
        field: "FrenchKind",
        label: ElectronicInvoicing.InvoicingEndpoint.selectLabel,
        sections: ElectronicInvoicing.InvoicingEndpoint.French.selectSections,
        hideRequired: true
      }), editable && identifierIsSiren ? JsxRuntime.jsx(AddressForm.InputText.make, {
        field: "Identifier",
        label: ElectronicInvoicing.InvoicingEndpoint.French.identifierLabel("Siren"),
        placeholder: ElectronicInvoicing.InvoicingEndpoint.French.identifierPlaceholder("Siren"),
        hideRequired: true
      }) : JsxRuntime.jsx(InputTextField.make, {
        label: ElectronicInvoicing.InvoicingEndpoint.French.identifierLabel("Siren"),
        disabled: true,
        value: CompanyLegalNumber.French.sirenFromSiret(values.identifier)
      }), tmp, tmp$1],
      grid: ["max-content", "1fr", "1fr", "1fr"]
    });
  }
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("settings_electronic_invoicing_page.address_fieldset.title"),
    description: I18n.t("settings_electronic_invoicing_page.address_fieldset.description"),
    children: JsxRuntime.jsx(AddressForm.Core.Provider.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [editing ? initialValue !== undefined ? JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(NextBanner.make, {
            children: JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t("settings_electronic_invoicing_page.address_fieldset.edit_banner.text")
            }),
            variation: "warning",
            title: I18n.t("settings_electronic_invoicing_page.address_fieldset.edit_banner.title")
          }), fieldsElement],
          space: "large"
        }) : fieldsElement : JsxRuntime.jsx(InputTextField.make, {
          label: I18n.t("settings_electronic_invoicing_page.address_fieldset.content.input_label"),
          disabled: true,
          value: ElectronicInvoicing.InvoicingEndpoint.formatOption(initialValue)
        }), JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx(TextAction.make, {
            text: I18n.t("settings_electronic_invoicing_page.address_fieldset.helpcenter_article_label"),
            highlighted: true,
            onPress: () => HelpCenter.showArticle(HelpCenter.eInvoicingSetupEndpoint)
          }), editing ? JsxRuntime.jsxs(Inline.make, {
            children: [initialValue !== undefined ? JsxRuntime.jsx(AddressForm.CancelButton.make, {
              label: I18n.t("Cancel"),
              onPress: () => setEditing(param => false)
            }) : null, JsxRuntime.jsx(AddressForm.SubmitButton.make, {
              label: initialValue === undefined ? I18n.t("settings_electronic_invoicing_page.address_fieldset.create_button_label") : I18n.t("Save"),
              tone: initialValue === undefined ? "brand" : "success",
              disabled: Primitive_object.equal(values, match.initialValues) && Stdlib_Option.isSome(initialValue) || Stdlib_Result.isError(match.validation),
              onSubmit: (param, values) => {
                captureEvent("settings_electronic_invoicing_address_click_save");
                return Future.mapOk(onSubmit(endpointFromValues(values, isBelgianShop)), undefined, () => {
                  setEditing(param => false);
                });
              }
            })],
            space: "small"
          }) : JsxRuntime.jsx(Button.make, {
            label: I18n.t("Edit"),
            icon: "edit",
            onPress: () => setEditing(param => true)
          })],
          space: "large",
          align: "spaceBetween"
        })],
        space: "large"
      }),
      propState: formPropState
    })
  });
}
let SettingsElectronicInvoicingAddressFieldset = {
  InvoicingEndpoint: undefined,
  FrenchKind: undefined,
  BelgianKind: undefined,
  AddressFormLenses: AddressFormLenses,
  AddressForm: AddressForm,
  shopIdentifier: shopIdentifier,
  initialValues: initialValues,
  endpointFromValues: endpointFromValues,
  schema: schema$1,
  make: SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAddressFieldset
};
function shouldRenderGuideFieldset(settingsResult) {
  if (typeof settingsResult !== "object") {
    return false;
  }
  if (settingsResult.TAG === "Reloading") {
    let match = settingsResult._0.result;
    if (match.TAG === "Ok") {
      return match._0 !== undefined;
    } else {
      return false;
    }
  }
  let match$1 = settingsResult._0.result;
  if (match$1.TAG === "Ok") {
    return match$1._0 !== undefined;
  } else {
    return false;
  }
}
function accountFieldsetRoute(shopId, settingsResult, setupRedirected) {
  let exit = 0;
  if (typeof settingsResult !== "object") {
    return "AccountFieldsetLoading";
  }
  exit = 2;
  if (exit === 2) {
    if (settingsResult._0.shopId !== shopId) {
      return "AccountFieldsetLoading";
    }
    if (typeof settingsResult === "object") {
      if (settingsResult.TAG === "Reloading") {
        let match = settingsResult._0.result;
        if (match.TAG === "Ok") {
          if (match._0 !== undefined && setupRedirected) {
            return "SetupRedirect";
          }
        } else {
          switch (match._0) {
            case "AccountNotFound":
              return "AccountSetupFieldset";
            case "Failure":
            case "UnexpectedFailure":
              break;
          }
        }
      } else {
        let match$1 = settingsResult._0.result;
        if (match$1.TAG === "Ok") {
          if (match$1._0 !== undefined && setupRedirected) {
            return "SetupRedirect";
          }
        } else {
          switch (match$1._0) {
            case "AccountNotFound":
              return "AccountSetupFieldset";
            case "Failure":
            case "UnexpectedFailure":
              break;
          }
        }
      }
    }
  }
  if (typeof settingsResult === "object") {
    if (settingsResult.TAG === "Reloading") {
      let match$2 = settingsResult._0.result;
      if (match$2.TAG !== "Ok") {
        return "AccountFieldsetError";
      }
      let settings = match$2._0;
      if (settings !== undefined) {
        return {
          TAG: "AccountStatusFieldset",
          _0: settings
        };
      } else {
        return "AccountFieldsetError";
      }
    }
    let match$3 = settingsResult._0.result;
    if (match$3.TAG !== "Ok") {
      return "AccountFieldsetError";
    }
    let settings$1 = match$3._0;
    if (settings$1 !== undefined) {
      return {
        TAG: "AccountStatusFieldset",
        _0: settings$1
      };
    } else {
      return "AccountFieldsetError";
    }
  }
}
function missingInvoicingAddress(shop) {
  if (ElectronicInvoicing.isShopFromBelgium(shop)) {
    if (StringHelpers.isEmptyOptionString(shop.invoicingEndpointId)) {
      return true;
    } else {
      return StringHelpers.isEmptyOptionString(shop.invoicingEndpointIdSchemeCode);
    }
  } else {
    return false;
  }
}
function updateSettingsResultWithThirdPartyToggle(shopId, value, settingsResult) {
  if (typeof settingsResult !== "object") {
    return settingsResult;
  }
  if (settingsResult.TAG !== "Done") {
    return settingsResult;
  }
  let match = settingsResult._0;
  let match$1 = match.result;
  if (match$1.TAG !== "Ok") {
    return settingsResult;
  }
  let settings = match$1._0;
  if (settings !== undefined && match.shopId === shopId) {
    return {
      TAG: "Done",
      _0: {
        shopId: shopId,
        result: {
          TAG: "Ok",
          _0: {
            user: settings.user,
            accountLink: settings.accountLink,
            emissionSubscription: settings.emissionSubscription,
            receptionSubscription: settings.receptionSubscription,
            usingThirdPartyEmission: settings.usingThirdPartyEmission,
            usingThirdPartyReception: value
          }
        }
      }
    };
  } else {
    return settingsResult;
  }
}
let forcedSignedReceptionShopEmail = "yves@leditvin.be";
function temporaryEnrollmentStatusForDisplay(shop, enrollmentStatus) {
  if (shop.email === forcedSignedReceptionShopEmail) {
    return "Signed";
  } else {
    return enrollmentStatus;
  }
}
function hideContractDownloadButton(shop) {
  return shop.email === forcedSignedReceptionShopEmail;
}
function SettingsElectronicInvoicingPage(props) {
  let __setupRedirected = props.setupRedirected;
  let setupRedirected = __setupRedirected !== undefined ? __setupRedirected : false;
  let authScope = Auth.useScope();
  let authState = Auth.useState();
  let logUser = Auth.useLogUser(undefined, undefined);
  let jwt = Stdlib_Option.getOr(Auth.getJwt(), "");
  let activeShop = Auth.useActiveShopExn();
  let match = React.useState(() => activeShop);
  let setShop = match[1];
  let shop = match[0];
  let selectedShopIdRef = React.useRef(shop.id);
  let selectShop = selected => {
    selectedShopIdRef.current = selected.id;
    setShop(param => selected);
  };
  let match$1 = React.useState(() => "NotAsked");
  let setSettingsResult = match$1[1];
  let settingsResult = match$1[0];
  let match$2 = React.useState(() => "NotAsked");
  let setContractDownloadResult = match$2[1];
  let contractDownloadResult = match$2[0];
  let match$3 = React.useState(() => {});
  let setNotification = match$3[1];
  let match$4 = React.useState(() => false);
  let setEnrollmentPollingStarted = match$4[1];
  let enrollmentPollingStarted = match$4[0];
  let fetchSettings = (asReloadOpt, clearNotificationOpt, shopId) => {
    let asReload = asReloadOpt !== undefined ? asReloadOpt : false;
    let clearNotification = clearNotificationOpt !== undefined ? clearNotificationOpt : true;
    if (clearNotification) {
      setNotification(param => {});
    }
    setSettingsResult(prev => {
      if (asReload) {
        return AsyncData.toBusy(prev);
      } else {
        return "Loading";
      }
    });
    return Future.tap(ElectronicInvoicing.Settings.SettingsRequest.make(shopId), result => {
      if (result.TAG !== "Ok") {
        let message = ElectronicInvoicing.Settings.SettingsRequest.messageFromFailure(result._0);
        if (message !== undefined) {
          setNotification(param => ({
            TAG: "Error",
            _0: message
          }));
        }
      }
      setSettingsResult(param => ({
        TAG: "Done",
        _0: {
          shopId: shopId,
          result: result
        }
      }));
    });
  };
  React.useEffect(() => {
    setEnrollmentPollingStarted(param => false);
    setContractDownloadResult(param => "NotAsked");
    let future = fetchSettings(true, undefined, shop.id);
    return () => Future.cancel(future);
  }, [shop.id]);
  let currentEnrollmentStatus;
  let exit = 0;
  let shopId;
  let settings;
  if (typeof settingsResult !== "object") {
    currentEnrollmentStatus = undefined;
  } else if (settingsResult.TAG === "Reloading") {
    let match$5 = settingsResult._0;
    let match$6 = match$5.result;
    if (match$6.TAG === "Ok") {
      let settings$1 = match$6._0;
      if (settings$1 !== undefined) {
        shopId = match$5.shopId;
        settings = settings$1;
        exit = 1;
      } else {
        currentEnrollmentStatus = undefined;
      }
    } else {
      currentEnrollmentStatus = undefined;
    }
  } else {
    let match$7 = settingsResult._0;
    let match$8 = match$7.result;
    if (match$8.TAG === "Ok") {
      let settings$2 = match$8._0;
      if (settings$2 !== undefined) {
        shopId = match$7.shopId;
        settings = settings$2;
        exit = 1;
      } else {
        currentEnrollmentStatus = undefined;
      }
    } else {
      currentEnrollmentStatus = undefined;
    }
  }
  if (exit === 1) {
    currentEnrollmentStatus = shopId === shop.id ? settings.receptionSubscription.enrollmentAgreementStatus : undefined;
  }
  React.useEffect(() => {
    if (enrollmentPollingStarted && currentEnrollmentStatus === "Signed") {
      setEnrollmentPollingStarted(param => false);
    }
  }, [enrollmentPollingStarted, currentEnrollmentStatus]);
  React.useEffect(() => {
    if (!enrollmentPollingStarted) {
      return;
    }
    let id = setInterval(() => {
      fetchSettings(true, false, shop.id);
    }, 5000);
    return () => {
      clearInterval(id);
    };
  }, [enrollmentPollingStarted, shop.id]);
  let handleSetup = (siretNumber, vatNumber, userFirstName, userLastName, corporateName, email, taxationRegime, employeesNumber) => {
    let shopId = shop.id;
    setNotification(param => {});
    return Future.tap(ElectronicInvoicing.Settings.SetupRequest.make(shopId, email, userFirstName, userLastName, siretNumber, vatNumber, corporateName, taxationRegime, employeesNumber), result => {
      if (result.TAG === "Ok") {
        logUser(jwt);
        if (selectedShopIdRef.current === shopId) {
          setShop(shop => {
            let newrecord = {
              ...shop
            };
            newrecord.siretNumber = Stdlib_Option.orElse(siretNumber, shop.siretNumber);
            newrecord.tvaNumber = Stdlib_Option.orElse(vatNumber, shop.tvaNumber);
            return newrecord;
          });
        }
        setNotification(param => ({
          TAG: "Ok",
          _0: I18n.t("settings_electronic_invoicing_page.account_creation_modal.success_message")
        }));
        fetchSettings(true, false, shopId);
        return Navigation.openRoute(SettingsRoutes.electronicInvoicingRoute);
      }
      let failure = result._0;
      setNotification(param => ({
        TAG: "Error",
        _0: ElectronicInvoicing.Settings.SetupRequest.messageFromFailure(failure)
      }));
    });
  };
  let handleThirdPartyToggle = value => {
    setNotification(param => {});
    setSettingsResult(prev => updateSettingsResultWithThirdPartyToggle(shop.id, value, prev));
    Future.get(ElectronicInvoicing.Settings.UpdateSettingsRequest.make(shop.id, value), result => {
      if (result.TAG === "Ok") {
        return;
      }
      let failure = result._0;
      setSettingsResult(prev => updateSettingsResultWithThirdPartyToggle(shop.id, !value, prev));
      setNotification(param => ({
        TAG: "Error",
        _0: ElectronicInvoicing.Settings.UpdateSettingsRequest.messageFromFailure(failure)
      }));
    });
  };
  let handleAddressUpdate = value => {
    let shopId = shop.id;
    let failureMessage = failure => Stdlib_Option.getOr(Stdlib_Option.map(failure, ElectronicInvoicing.Settings.UpdateShopInvoicingAddressRequest.messageFromFailure), Request.serverErrorMessage);
    setNotification(param => {});
    return Future.map(Future.tap(ElectronicInvoicing.Settings.UpdateShopInvoicingAddressRequest.make(shopId, Stdlib_Option.map(value, value => value.endpointId), Stdlib_Option.map(value, value => value.schemeCode), Stdlib_Option.flatMap(value, value => value.schemeType)), result => {
      if (result.TAG === "Ok") {
        logUser(jwt);
        if (selectedShopIdRef.current === shopId) {
          return setShop(shop => {
            let newrecord = {
              ...shop
            };
            newrecord.invoicingEndpointIdSchemeType = Stdlib_Option.flatMap(value, value => value.schemeType);
            newrecord.invoicingEndpointIdSchemeCode = Stdlib_Option.map(value, value => value.schemeCode);
            newrecord.invoicingEndpointId = Stdlib_Option.map(value, value => value.endpointId);
            return newrecord;
          });
        } else {
          return;
        }
      }
      if (selectedShopIdRef.current !== shopId) {
        return;
      }
      let failure = result._0;
      setNotification(param => ({
        TAG: "Error",
        _0: failureMessage(failure)
      }));
    }), undefined, result => Stdlib_Result.mapError(Stdlib_Result.map(result, param => {}), failureMessage));
  };
  let handleContractDownload = () => {
    setNotification(param => {});
    setContractDownloadResult(param => "Loading");
    Future.get(Future.flatMapOk(Future.mapError(ElectronicInvoicing.Settings.DownloadContractRequest.make(shop.id), undefined, param => {}), undefined, blob => Future.mapError(TriggerDownload.fromBlob(blob, `contrat-cecurity-` + shop.name.replaceAll(" ", "_") + `.pdf`), undefined, () => {})), result => {
      if (result.TAG === "Ok") {
        return setContractDownloadResult(param => ({
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: undefined
          }
        }));
      }
      setContractDownloadResult(param => ({
        TAG: "Done",
        _0: {
          TAG: "Error",
          _0: undefined
        }
      }));
      setNotification(param => ({
        TAG: "Error",
        _0: ElectronicInvoicing.Settings.DownloadContractRequest.failureMessage
      }));
    });
  };
  let renderAccountFieldset = () => {
    if (typeof authState !== "object" || authState.TAG === "Logging") {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
    } else {
      return JsxRuntime.jsx(SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountSetupFieldset, {
        shop: shop,
        user: authState._0.user,
        setupRedirected: setupRedirected,
        onSetup: handleSetup
      });
    }
  };
  let renderAccountFieldsetLoading = () => JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("settings_electronic_invoicing_page.account_fieldset.title"),
    description: I18n.t("settings_electronic_invoicing_page.account_fieldset.description"),
    children: JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    })
  });
  let renderAccountStatusFieldset = settings => {
    let thirdPartyPlatformEnabled = settings.usingThirdPartyReception;
    let isBelgianShop = ElectronicInvoicing.isShopFromBelgium(shop);
    let missingInvoicingAddress$1 = missingInvoicingAddress(shop);
    let enrollmentStatus = settings.receptionSubscription.enrollmentAgreementStatus;
    let enrollmentStatus$1 = temporaryEnrollmentStatusForDisplay(shop, enrollmentStatus);
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAccountStatusFieldset, {
        accountLink: settings.accountLink,
        accountLoginName: settings.user.loginName,
        enrollmentStatus: enrollmentStatus$1,
        enrollmentAgreementLink: settings.receptionSubscription.enrollmentAgreementLink,
        thirdPartyPlatformEnabled: thirdPartyPlatformEnabled,
        missingInvoicingAddress: missingInvoicingAddress$1,
        isBelgianShop: isBelgianShop,
        contractDownloadPending: AsyncData.isBusy(contractDownloadResult),
        hideContractDownloadButton: shop.email === forcedSignedReceptionShopEmail,
        onContractDownload: handleContractDownload,
        onThirdPartyPlatformToggle: handleThirdPartyToggle,
        onEnrollmentAgreementStart: () => setEnrollmentPollingStarted(param => true)
      }), JsxRuntime.jsx(CanarySeparator.make, {
        orientation: "horizontal"
      }), JsxRuntime.jsx(SettingsElectronicInvoicingPage$SettingsElectronicInvoicingAddressFieldset, {
        shopId: shop.id,
        initialValue: ElectronicInvoicing.InvoicingEndpoint.make(shop.invoicingEndpointIdSchemeType, shop.invoicingEndpointIdSchemeCode, shop.invoicingEndpointId),
        siret: shop.siretNumber,
        vatNumber: shop.tvaNumber,
        isBelgianShop: isBelgianShop,
        onSubmit: handleAddressUpdate
      })]
    });
  };
  let tmp;
  let exit$1 = 0;
  if (typeof settingsResult !== "object") {
    tmp = JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  } else {
    exit$1 = 1;
  }
  if (exit$1 === 1) {
    let tmp$1;
    tmp$1 = authScope.TAG === "Organisation" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(SettingsElectronicInvoicingPage$SettingsElectronicInvoicingShopFieldset, {
        shop: shop,
        onShopChange: selectShop
      }), JsxRuntime.jsx(CanarySeparator.make, {
        orientation: "horizontal"
      })]
    }) : null;
    let settings$3 = accountFieldsetRoute(shop.id, settingsResult, setupRedirected);
    let tmp$2;
    if (typeof settings$3 !== "object") {
      switch (settings$3) {
        case "AccountFieldsetLoading":
          tmp$2 = renderAccountFieldsetLoading();
          break;
        case "AccountSetupFieldset":
          tmp$2 = renderAccountFieldset();
          break;
        case "SetupRedirect":
          tmp$2 = JsxRuntime.jsx(Navigation.Redirect.make, {
            route: SettingsRoutes.electronicInvoicingRoute
          });
          break;
        case "AccountFieldsetError":
          tmp$2 = JsxRuntime.jsx(Placeholder.make, {
            status: "Error"
          });
          break;
      }
    } else {
      tmp$2 = renderAccountStatusFieldset(settings$3._0);
    }
    tmp = JsxRuntime.jsxs(Stack.make, {
      children: [tmp$1, tmp$2, shouldRenderGuideFieldset(settingsResult) ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(CanarySeparator.make, {
          orientation: "horizontal"
        }), JsxRuntime.jsx(SettingsElectronicInvoicingPage$SettingsElectronicInvoicingGuideFieldset, {})]
      }) : null],
      space: "large"
    });
  }
  return JsxRuntime.jsxs(NextPage.make, {
    children: [JsxRuntime.jsx(make, {
      notification: match$3[0]
    }), tmp],
    title: I18n.t("settings_electronic_invoicing_page.title"),
    titlePrepender: JsxRuntime.jsx(NextBadge.make, {
      kind: "Information",
      label: I18n.t("BETA"),
      size: "S"
    })
  });
}
let make$1 = React.memo(SettingsElectronicInvoicingPage);
export { SettingsElectronicInvoicingNotificationBanner, SettingsElectronicInvoicingShopFieldset, SettingsElectronicInvoicingAccountCreationModal, SettingsElectronicInvoicingAccountSetupFieldset, SettingsElectronicInvoicingAccountStatusFieldset, SettingsElectronicInvoicingGuideFieldset, SettingsElectronicInvoicingAddressFieldset, shouldRenderGuideFieldset, accountFieldsetRoute, missingInvoicingAddress, updateSettingsResultWithThirdPartyToggle, forcedSignedReceptionShopEmail, temporaryEnrollmentStatusForDisplay, hideContractDownloadButton, make$1 as make };
/* make Not a pure module */